// extracted by mini-css-extract-plugin
export default {"root":"PlasmicQ_root__MkHLg","svg__qhBhd":"PlasmicQ_svg__qhBhd__2czhH","freeBox":"PlasmicQ_freeBox__mi7sH","slotTargetSlot":"PlasmicQ_slotTargetSlot__U+-F7"};